import Api from "./Api.js";

const resource = "/shopping-carts";

export default {
  import(cartId, data) {
    return Api.post(`${resource}/${cartId}/new-import`, data);
  }
};
